module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-dress-image-3-1e6a857f8c4d8f96f28088526183bce6.png";